// extracted by mini-css-extract-plugin
export default {"cellContainer":"styles_cellContainer__DMJSk","cellContainerSelected":"styles_cellContainerSelected__tm-um"};